async function fetchCarlineRanges(params) {
    try {
        const url = `${params.webApiBaseUrl}/eec-carline-ranges/v1/${params.country.toLowerCase()}/${params.language}`;
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        return null;
    }
}
export async function fetchCarlineById(params) {
    const eecRanges = await fetchCarlineRanges(params);
    return eecRanges?.carlines.find((carline) => carline.carlineId === params.carlineId);
}
//# sourceMappingURL=carline.js.map